import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';
import { FormsModule, type NgForm } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';

import { sendResetPasswordEmail } from '@asset-solutions/customer-portal/auth/data-access';
import { ColorMode } from '@asset-solutions/shared/ui';
import { Store } from '@ngrx/store';

import { SplashPageComponent } from '../splash-page.component';

@Component({
  selector: 'auth-forgot-password',
  imports: [FormsModule, MatInputModule, MatButton, SplashPageComponent],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordComponent {
  public readonly form = viewChild.required<NgForm>('forgotPasswordForm');
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  protected readonly colorMode = inject(ColorMode);

  protected emailAddress = '';

  protected navigateBack(): void {
    this.router.navigateByUrl('/login');
  }

  protected submitReset(): void {
    this.store.dispatch(sendResetPasswordEmail({ email: this.emailAddress }));
    this.form().reset();
  }
}
